export const environment = {
    production: true,
    //for deployment environment
    apiUri:  window['env']['apiUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/user-manager',
    loanUri:  window['env']['loanUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/loan/v1/secured',
    jobUri:  window['env']['jobUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/job/v1/secured',
    savingUri:  window['env']['savingUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/saving/v1/secured',
    printingUri:  window['env']['printingUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/printing/v1/secured',
    collateralUri:  window['env']['collateralUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/loan/v1/secured',
    notificationUri:  window['env']['notificationUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/notification-service/api/v1/secured',
    depositUri:  window['env']['depositUri'] || 'https://doocat-core-staging.doocat.dev.energizeglobal.live/deposit',
    // for Demo server
    //  apiUri: 'http://cbanking-demo-user-manager.tce.loc',
    //  loanUri: 'http://cbanking-demo-loan.tce.loc/v1/secured',
    loan_repayment: {'LOAN_REPAYMENT_ACCOUNT':"14100"}

};
